// extracted by mini-css-extract-plugin
module.exports = {"graph":"style__graph__KjpWg","topLabel":"style__topLabel__-87q8","bottomLabel":"style__bottomLabel__Sinib"};